import { CommonCivilStatusCrumbs } from './breadcrumb';

export const NotesTextListCrumbs = [
  ...CommonCivilStatusCrumbs,
  {
    name: 'Lista Annotazioni',
    path: '/stato-civile/annotazioni',
  },
];

export const NotesTextNewCrumbs = [
  ...NotesTextListCrumbs,
  {
    name: 'Nuova Annotazione',
    path: '/stato-civile/annotazioni/nuovo',
  },
];

export const NotesTextEditCrumbs = [
  ...NotesTextListCrumbs,
  {
    name: 'Modifica Annotazioni',
    path: '/stato-civile/annotazioni/modifica',
  },
];

export const NotesTextVisualizeCrumbs = [
  ...NotesTextListCrumbs,
  {
    name: 'Visualizza Annotazioni',
    path: '/stato-civile/annotazioni/visualizza',
  },
];
